import { StorageKeys } from '../../services';
// Store condiviso a livello di modulo per lo stato "fatto" delle azioni meal prep
var doneMap = {};
var loaded = false;
var hydrating = null;
var listeners = new Set();
var emit = function () {
    listeners.forEach(function (listener) { return listener(); });
};
export var mealPrepDoneStore = {
    subscribe: function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    },
    getDoneMap: function () { return doneMap; },
    isLoaded: function () { return loaded; },
    hydrate: function (storage) {
        if (loaded) {
            return Promise.resolve();
        }
        if (hydrating) {
            return hydrating;
        }
        hydrating = storage
            .getItem(StorageKeys.MEAL_PREP_DONE)
            .then(function (stored) {
            if (stored) {
                doneMap = JSON.parse(stored);
            }
        })
            .catch(function () { return undefined; })
            .then(function () {
            loaded = true;
            hydrating = null;
            emit();
        });
        return hydrating;
    },
    setDoneMap: function (storage, next) {
        doneMap = next;
        emit();
        storage
            .setItem(StorageKeys.MEAL_PREP_DONE, JSON.stringify(next))
            .catch(function () { return undefined; });
    },
    // Svuota la mappa in memoria e riporta lo store al suo stato iniziale, così
    // il prossimo hydrate rilegge dallo storage.
    reset: function () {
        doneMap = {};
        loaded = false;
        hydrating = null;
        emit();
    },
};
